// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const heracross: PokeData = {
  "id": 214,
  "name": "heracross",
  "height": 15,
  "weight": 540,
  "base_experience": 175,
  "types": [
    PokeType.BUG,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "swords-dance",
    "horn-attack",
    "fury-attack",
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "pin-missile",
    "leer",
    "counter",
    "slash",
    "reversal",
    "endure",
    "megahorn",
    "rock-smash",
    "brick-break",
    "arm-thrust",
    "bullet-seed",
    "aerial-ace",
    "feint",
    "close-combat",
    "night-slash",
    "chip-away",
    "throat-chop"
  ],
  "moves": [
    "tackle",
    "pin-missile",
    "leer",
    "rock-smash",
    "bullet-seed",
    "aerial-ace",
    "close-combat",
    "night-slash",
    "lunge",
    "double-kick",
    "string-shot",
    "meteor-assault",
    "karate-chop"
  ],
  "evolution_chain": {
    "id": 108,
    "item": null,
    "species": [
      {
        "name": "heracross",
        "order": 244,
        "types": [
          PokeType.BUG,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 113,
    "speed": 116,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
